import { registerTab } from "lib/@components/tabs"
import { TaskCriticality } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/criticality/task-criticality"

registerTab({
    tab: "assetTaskPerspective",
    id: "criticality",
    title: "Criticality",
    content: <TaskCriticality $lazy />,
})
